module.exports = __webpack_public_path__ + "img/icon25.328b4bbe.328b4bbe.svg";